module.exports = __webpack_public_path__ + "static/media/PartnerZalandooLogo.b86f9a33.png";